import "./main.css";
import "./popup_tips.css";
import React, {useRef, useContext, useEffect, useState} from "react";
import TextsContext from "../../TextsContent";
import {useNavigate, useLocation} from "react-router-dom";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import {ReactComponent as MainLogo} from './img/avo-welcome.svg';
import {ReactComponent as MenuWaterIcon} from './img/menu-water-icon.svg';
import {ReactComponent as MenuWorkoutIcon} from './img/menu-workout-icon.svg';
import {ReactComponent as MenuFoodIcon} from './img/menu-food-icon.svg';
import {ReactComponent as MenuSleepIcon} from './img/menu-sleep-icon.svg';
import {useDispatch} from "react-redux";
import {hydrateWorkoutFeedback} from "../../store/slices/workoutFeedback";


const MainPage = () => {
  const navigate = useNavigate();
  const texts = useContext(TextsContext);
  const userID = localStorage.getItem("userHash") ?? null;
  const userProfileData =
    JSON.parse(localStorage.getItem(userID))?.userProfileData ?? null;
  const refTipsPopup = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);
  const location = useLocation();
  const isMainPage = location.pathname === "/main-page";
  const mainContainerRef = useRef(null);
  const timerFadeIn = useRef(null);
    const dispatch = useDispatch();

  useEffect(() => {
    if (!userID) return;

    const workoutFeedback =
      JSON.parse(localStorage.getItem(userID))?.workoutFeedbackData ?? [];
    dispatch(hydrateWorkoutFeedback(workoutFeedback));
  }, [dispatch, userID]);


  useEffect(() => {
    if (mainContainerRef.current) {
      mainContainerRef.current.classList.add('main-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      mainContainerRef.current.classList.remove('main-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);

  const removePopup = () => {
    if (popupRef.current) {
      popupRef.current.classList.add("deactivated-tip");

      setTimeout(() => {
        if (popupRef.current) {
          popupRef.current.classList.remove("deactivated-tip");
        }
      }, 910);
    }
  };

  const closePopup = (delay) => {
    const lastShownDate = localStorage.getItem("lastTipShownDate");
    const today = new Date().toDateString();

    if (lastShownDate !== today) {
      setShowPopup(true);
      refTipsPopup.current = setTimeout(() => {
        removePopup();
        setTimeout(() => {
          localStorage.setItem("lastTipShownDate", today);
          setShowPopup(false);
        }, 910);
      }, delay); //4110
    }

    return () => {
      if (refTipsPopup.current) {
        clearTimeout(refTipsPopup.current);
      }
    };
  };

  useEffect(() => {
    closePopup(6510);
  }, []);

  const getTipIndex = () => {
    const today = new Date();
    const dayOfMonth = today.getDate();
    return (dayOfMonth - 1) % texts.dailyTips.length;
  };

  const handleClosePopup = () => {
    const today = new Date().toDateString();
    removePopup();

    setTimeout(() => {
      localStorage.setItem("lastTipShownDate", today);
      setShowPopup(false);
    }, 910);

    if (refTipsPopup.current) {
      clearTimeout(refTipsPopup.current);
    }
  };

  const handleCategoryHome = (route) => () => {
    closePopup(0);
    navigate(route);
  };

  return (
    <>
      <div ref={mainContainerRef}
           className="main-container main-container-main">
        <div className={`outer-content ${isMainPage ? "main-page " : ""}`}>
          <MainLogo
            className="main-logo main-logo-main"
          />
          <p className="main-text main-text-main">
            {texts.main["main-text"]} <br/>{" "}
            {userProfileData ? userProfileData.userName : "User"}!
          </p>
          <div className="site-title site-title-main">
            <img
              className="main-logo-mini"
              width='96'
              height='24'
              loading="lazy"
              src={require("./img/logo-mini.png")}
              alt="main logo"
            />
          </div>
        </div>

        <div className="inner-content inner-content-main">
          {/* 1 */}
          <div
            onClick={handleCategoryHome(RoutesToPages.waterBalance)}
            className="menu-item menu-item--water menu-item-main menu-item--water-main"
          >
            <div className="menu-item__icon menu-item__icon-main">
              <MenuWaterIcon className="menu-item__image menu-item__image-main"/>
            </div>
            <div className="menu-text__wrapper menu-text__wrapper-main">
              <span className="menu-item__title menu-item__title-main">
                {texts.main["menu-item__title-water"]}
              </span>
              <span className="menu-item__text menu-item__text-main">
                {texts.main["menu-item__text-water"]}
              </span>
            </div>
          </div>

          {/* 2 */}
          <div
            onClick={handleCategoryHome(RoutesToPages.workoutPage)}
            className="menu-item menu-item--workout menu-item-main menu-item--workout-main"
          >
            <div className="menu-item__icon menu-item__icon-main">
              <MenuWorkoutIcon className="menu-item__image menu-item__image-main"/>
            </div>
            <div className="menu-text__wrapper menu-text__wrapper-main">
              <span className="menu-item__title menu-item__title-main">
                {texts.main["menu-item__title-workout"]}
              </span>
              <span className="menu-item__text menu-item__text-main">
                {texts.main["menu-item__text-workout"]}
              </span>
            </div>
          </div>

          {/* 3 */}
          <div
            onClick={handleCategoryHome(RoutesToPages.foodCategory)}
            className="menu-item menu-item--food menu-item-main menu-item--food-main"
          >
            <div className="menu-item__icon menu-item__icon-main">
              <MenuFoodIcon className="menu-item__image menu-item__image-main"/>
            </div>
            <div className="menu-text__wrapper menu-text__wrapper-main">
              <span className="menu-item__title menu-item__title-main">
                {texts.main["menu-item__title-food"]}
              </span>
              <span className="menu-item__text menu-item__text-main">
                {texts.main["menu-item__text-food"]}
              </span>
            </div>
          </div>

          {/* 4 */}
          <div
            onClick={handleCategoryHome(RoutesToPages.sleepPage)}
            className="menu-item menu-item--sleep menu-item-main menu-item--sleep-main"
          >
            <div className="menu-item__icon menu-item__icon-main">
              <MenuSleepIcon className="menu-item__image menu-item__image-main"/>
            </div>
            <div className="menu-text__wrapper menu-text__wrapper-main">
              <span className="menu-item__title menu-item__title-main">
                {texts.main["menu-item__title-sleep"]}
              </span>
              <span className="menu-item__text menu-item__text-main">
                {texts.main["menu-item__text-sleep"]}
              </span>
            </div>
          </div>
        </div>

        {/* Попап */}
        <div
          ref={popupRef}
          className={`popup__united ${
            showPopup ? "active-tip active-tip-main" : ""
          }`}
        >
          <div
            onClick={handleClosePopup}
            className="popup__close popup__close-main"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              className="popup__progress_circle popup__progress_circle-main"
            >
              <circle className="bg bg-main"></circle>
              <circle className="fg fg-main"></circle>
            </svg>
          </div>
          <h3 className="popup__title popup__title-main">
            Your tip of the day
          </h3>
          <span className="popup__text popup__text-main">
            {texts.dailyTips[getTipIndex()]}
          </span>
        </div>
      </div>
    </>
  );
};

export default MainPage;
